module.exports = __webpack_public_path__ + "static/media/vials.a06f25ca.svg";